import { Button } from 'antd'
import React from 'react'

function BlockButton({children}) {
  return (
    <Button type="primary" block className='auf-button'>{children}</Button>
  )
}

export default BlockButton